import { Lock } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { BASICS, MODULES, toggleModule } from "@/lib/modules";

// Basics are always on; tick the extra features you want.
export const CompanyModulesPicker = ({ value, onChange, disabled }) => (
  <div className="grid gap-2" data-testid="modules-picker">
    <div className="flex items-start gap-3 rounded-lg border border-primary/30 bg-primary/5 p-3" data-testid="module-basic">
      <Checkbox checked disabled className="mt-0.5" aria-label="Basics, always included" />
      <span className="flex-1">
        <span className="flex items-center gap-1.5 text-sm font-medium">Basic <Lock className="w-3 h-3 text-muted-foreground" /></span>
        <span className="block text-xs text-muted-foreground">{BASICS}. Always included.</span>
      </span>
    </div>
    {MODULES.map((m) => (
      <label key={m.key} className={`flex items-start gap-3 rounded-lg border p-3 cursor-pointer transition-colors hover:bg-muted ${value.includes(m.key) ? "border-primary" : "border-border"}`}>
        <Checkbox checked={value.includes(m.key)} disabled={disabled} onCheckedChange={(v) => onChange(toggleModule(value, m.key, !!v))}
          className="mt-0.5" data-testid={`module-option-${m.key}`} />
        <span>
          <span className="block text-sm font-medium">{m.label}</span>
          <span className="block text-xs text-muted-foreground">{m.desc}{m.needs ? " Turns on the client list too." : ""}</span>
        </span>
      </label>
    ))}
  </div>
);
